'use strict';
const angular = require('angular');

export class fullcalendarWidgetComponent {

  constructor($uibModal, CalendarEventService, Auth, dialogs) {
    'ngInject';

    this.$uibModal = $uibModal;
    this.CalendarEventService = CalendarEventService;
    this.Auth = Auth;
    this.dialogs = dialogs;

    this.eventSources =  [];
    var eventSource = {
      events: []
    };

    this.eventSources.push(eventSource);
  }

  $onInit() {
    let types = [];

    if (this.type) {
      types = this.type.split(',');
    }

    this._id = this.calendarId || 'fullcalendar';

    this.uiConfig = {
      calendar: {
        timezone: 'local',
        editable: false,
        defaultView: this.defaultView || 'month',
        minTime: this.minTime || '06:00:00',
        slotDuration: this.slotDuration || '00:30:00',
        height: 'auto',
        allDaySlot: this.allDaySlot === 'true',
        header: {
          left: this.left || 'title',
          center: this.center || 'month,agendaWeek,listMonth',
          right: this.right || 'today prev,next'
        },
        viewRender: (view, el) => {
          /* This is a hack, because the stick property of the event doesn't work with recurring events,
          so that these will appear multiple times per day - that's a bug.
          This hack solved the stick issue without using stick itself and thus corrupting recurring events:
          https://github.com/angular-ui/ui-calendar/issues/276 */

          jQuery('#'+this._id).fullCalendar('removeEvents');
          this.eventSources.forEach(eventSource => {
            jQuery('#'+this._id).fullCalendar('addEventSource', eventSource);
          })

        },
        eventRender: (event, el) => {
          // Recurring Events
          if (event.isRecurring) {
            if (!(event.start.isBefore(event.range.end) && event.start.isAfter(event.range.start)))
              return false;
          }
        },
        eventClick: (calendarEvent, jsEvent, view) => {

          if (this.public) {
            this.dialogs.notify("Event Details","Event details are only visible when logged in");
            return;
          }

          var that = this;

          var modalInstance = this.$uibModal.open({
            animation: true,
            component: 'calendarEventDetail',
            resolve: {
              calendarEvent: function () {
                return calendarEvent;
              },
              config: function () {
                return {
                  userHasPermission: that.Auth.isAdminSync()
                    || (that.Auth.getCurrentUserSync()._id === calendarEvent.meta.creationUser)
                }
              }
            }
          });

          modalInstance.result.then(
            function (result) {

              if (result.action === 'removed') {
                that.$timeout(() => {
                  that.getData();
                }, 0);
              }

            },
            function () {
            }
          );

        }
      }
    };

    this.CalendarEventService.query(data => {
      data.forEach(evt => {

        var event = evt;

        if (types.length && !types.includes(event.type)) {
            return;
        }

        event.orig = {
          start: event.start,
          end: event.end
        };

        if (event.isRecurring) {
          event.range = {start: event.start, end: event.recurrence.until};

          event.start = moment(event.start).format("HH:mm");

          if (event.end)
            event.end = moment(event.end).format("HH:mm");

          event.dow = event.recurrence.dayOfWeek;
          event.id = event._id;
        }

        this.eventSources[0].events.push(event);
      });
    }, err => {
      console.log('could not retrieve newest events');
    }) ;
  }
}

export default angular.module('conduuApp.fullcalendarWidget', [])
  .component('fullcalendarWidget', {
    template: `<div ng-if="$ctrl.uiConfig.calendar" id="{{$ctrl._id}}" ui-calendar="$ctrl.uiConfig.calendar" class="span8 calendar" ng-model="$ctrl.eventSources"></div>`,
    bindings: {
     count: '@',
     calendarId: '@',
     type: '@',
    defaultView: '@',
    minTime: '@',
    slotDuration: '@',
    allDaySlot: '@',
    left: '@',
    center: '@',
    right: '@'
    },
    controller: fullcalendarWidgetComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/fullcalendar-widget/fullcalendar-widget.component.js